"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var format_1 = __importDefault(require("date-fns/format"));

var react_1 = __importDefault(require("react"));

var react_text_mask_1 = __importDefault(require("react-text-mask"));

var createAutoCorrectedDatePipe_1 = __importDefault(require("text-mask-addons/dist/createAutoCorrectedDatePipe"));

var config_1 = require("../config");

var Input_1 = require("../Input");

var TimeInput =
/** @class */
function (_super) {
  __extends(TimeInput, _super);

  function TimeInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TimeInput.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        onChange = _a.onChange,
        style = _a.style,
        _b = _a.variant,
        variant = _b === void 0 ? Input_1.InputVariant.Grey : _b;
    var stringValue;

    if (typeof value === 'string') {
      stringValue = value;
    } else if (value instanceof Date) {
      stringValue = format_1.default(value, 'HH:mm');
    } // I know it looks strange but text-mask-addons realy has MM identifier for minutes and mm for months...


    var autoCorrectedDatePipe = createAutoCorrectedDatePipe_1.default('HH:MM');
    var b = config_1.block('input');
    var cn = b({
      white: variant === Input_1.InputVariant.White,
      grey: variant === Input_1.InputVariant.Grey
    });
    return react_1.default.createElement("div", {
      className: b('container'),
      style: style
    }, react_1.default.createElement(react_text_mask_1.default, {
      className: cn,
      mask: [/[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/],
      keepCharPositions: true,
      value: stringValue,
      onChange: onChange,
      pipe: autoCorrectedDatePipe,
      showMask: true
    }));
  };

  return TimeInput;
}(react_1.default.Component);

exports.default = TimeInput;